export const getOptionsFromObjectMapping = (mapping) => {
  const UUIDKeys = Object.keys(mapping);

  return UUIDKeys.map((key) => ({ value: key, label: mapping[key] }));
};

export const getValueFromObject = (object) => object.value;
